import React, { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import Layout from "../../components/layout/Layout";
// import Banner from "../../components/banner";
import HeroSection from "../../components/heroSection";
import BeacomeSupplier from "../../components/becomeSupplier";
import styles from "./styles.module.css";

function Supplier() {
  const { data } = useContext(LanguageContext);
  return (
    <Layout>
      {/* <Banner
        id="supplier"
        banner={`${data.banners[0].img}`}
        bannerAlt={"fruits"}
        bannerTitle={data.banners[0].title}
      /> */}
      <div className={styles.mobileGif}>
        <img src={`${data.banners[0].imgMobile}`} alt={"fruits"} />
      </div>
      <div className={styles.banner} id="supplier">
        <img src={`${data.banners[0].img}`} alt={"fruits"} />
        <h1 className={styles.bannerTitle}>{data.banners[0].title}</h1>
      </div>
      <HeroSection
        heroImage={data.supplierContent.img}
        p1={data.supplierContent.p1}
        p2={data.supplierContent.p2}
        p3={data.supplierContent.p3}
      />

      <BeacomeSupplier />
    </Layout>
  );
}

export default Supplier;
